import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { Outlet, Route, Routes } from 'react-router';
import { RequireAuth } from '@src/components';
import AppLayout from '@src/components/AppLayout';
import { useSession } from '@src/hooks/useSession';
import { identifySentryUser } from '../services/sentry';
import AuthRoutes from './auth';
import DashboardPage from './dashboard/dashboard.page';
import { DocumentsPage } from './documents/documents.page';
import NotFoundPage from './NotFound.page';
import OrderRoutes from './orders';

const SentryRoutes = Sentry.withSentryReactRouterV7Routing(Routes);

function PagesRoot(): JSX.Element {
  const { userId } = useSession();

  useEffect(() => {
    if (!userId) return;

    identifySentryUser({
      id: userId,
    });
  }, [userId]);

  return (
    <SentryRoutes>
      <Route path="auth/*" element={<AuthRoutes />} />
      <Route
        element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="documents" element={<DocumentsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
      <Route
        element={
          <RequireAuth>
            <Outlet />
          </RequireAuth>
        }
      >
        <Route path="orders/*" element={<OrderRoutes />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </SentryRoutes>
  );
}

export default PagesRoot;
